/**
 * sts-quote-prefill.js
 *
 * Tiny, vanilla, dependency-free prefill for the STS request-a-quote form
 * (sections/sts-form.liquid). Reads query-string params appended by the
 * calculator's "Add result to quote" link (see updateQuoteCta() in
 * assets/sts-calculator.js) and fills the matching field on this page's
 * enquiry form.
 *
 * Matching strategy, per param, in order:
 *   1. An element carrying `data-sts-autofill="<param>"` — this covers both
 *      the block-level "Prefill key" field setting and the fixed hidden
 *      context fields rendered when sections/sts-form.liquid's "Capture
 *      calculator context" setting is on (contact[Product], contact[Product
 *      URL], contact[Calculated LM], contact[Board count], contact[Area m2],
 *      contact[Wastage %]).
 *   2. Falls back to case-insensitive substring matching against a field's
 *      <label> text, for editor-configured fields that have not set a
 *      Prefill key. The form itself is targeted by its id prefix
 *      (`sts-form-{{ section.id }}`, set in sections/sts-form.liquid via
 *      the {% form %} tag's `id:` param) rather than a `.sts-form` class,
 *      since this file is the only change permitted to that section.
 *
 * Never overwrites a field that already has a value (e.g. a bounced
 * validation resubmit), and silently ignores any query param it does not
 * recognise or cannot find a matching field for.
 */
(function () {
  'use strict';

  // Every query-string param this script understands. Order does not
  // matter — each is looked up independently.
  var PARAMS = [
    'product',
    'product_url',
    'quantity',
    'quantity_lm',
    'board_length',
    'boards',
    'area',
    'wastage',
    'postcode',
    'species',
    'dimensions',
  ];

  // Label-substring fallback, used only when no data-sts-autofill target
  // exists for a given param. Params with no sensible legacy label (e.g.
  // product_url, quantity_lm, boards, area, wastage) simply have no entry
  // here and are skipped by the fallback.
  var LABEL_FALLBACK = {
    product: 'product or species',
    quantity: 'quantity in lm or m',
    board_length: 'preferred board length',
    postcode: 'postcode',
    species: 'product or species',
    dimensions: 'dimensions and profile',
  };

  function normalise(text) {
    return (text || '').trim().toLowerCase();
  }

  function findFieldByAutofillKey(form, key) {
    return form.querySelector('[data-sts-autofill="' + key + '"]');
  }

  function findFieldByLabel(form, labelContains) {
    var labels = form.querySelectorAll('label');
    for (var i = 0; i < labels.length; i++) {
      var label = labels[i];
      if (normalise(label.textContent).indexOf(labelContains) === -1) continue;

      var forId = label.getAttribute('for');
      var field = forId ? document.getElementById(forId) : null;
      if (!field) field = label.querySelector('input, textarea');

      if (field && (field.tagName === 'INPUT' || field.tagName === 'TEXTAREA')) {
        return field;
      }
    }
    return null;
  }

  function findField(form, param) {
    var field = findFieldByAutofillKey(form, param);
    if (field) return field;

    var labelContains = LABEL_FALLBACK[param];
    if (!labelContains) return null;

    return findFieldByLabel(form, labelContains);
  }

  function prefill() {
    var form = document.querySelector('form[id^="sts-form-"]');
    if (!form) return;

    var params = new URLSearchParams(window.location.search);
    if (!params.toString()) return;

    PARAMS.forEach(function (param) {
      var value = params.get(param);
      if (value === null || value.trim() === '') return;

      var field = findField(form, param);
      if (!field) return;
      if (field.value && field.value.trim() !== '') return; // never overwrite

      field.value = value;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prefill);
  } else {
    prefill();
  }
})();
